import { FormGroup, ValidatorFn } from '@angular/forms';
import { SearchPricingControls } from './builder/SearchPricingFormBuilder';
import { FormGroupHelper } from './FormGroupHelper';
import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { SearchPricingModel } from '../search-pricing.model';

export class SearchPricingFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<SearchPricingControls> {
  name = 'searchPricingForm';
  protected declare form: FormGroup;
  updated = false;
  controls: SearchPricingControls;

  constructor(formName: string, controls: SearchPricingControls, validators?: ValidatorFn[]) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  value(): any {
    return this.form.value;
  }

  updateForm(model: SearchPricingModel): void {
    // never used for now
    this.form.patchValue(model);
    this.updated = true;
  }

  updateModel(model: SearchPricingModel): void {
    model.quantity = this.controls.quantity.value;
    model.pickupCountry = this.controls.pickupAddress.controls.country.value;
    model.pickupZipCode = this.controls.pickupAddress.controls.zipCode.value;
    model.pickupInseeCode = this.controls.pickupAddress.controls.cityCode.value;
    model.deliveryCountry = this.controls.deliveryAddress.controls.country.value;
    model.deliveryZipCode = this.controls.deliveryAddress.controls.zipCode.value;
    model.deliveryInseeCode = this.controls.deliveryAddress.controls.cityCode.value;
  }
}
